import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL } from "@/lib/legalContent";
import { t } from "@/lib/i18n";

export default function LegalPage({ type }) {
  const { lang } = useParams();
  const doc = (LEGAL[type] || {})[lang] || (LEGAL[type] || {}).tr;

  useEffect(() => {
    if (doc) document.title = `${doc.title} — Sıfır Bir Tuning`;
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) { robots = document.createElement("meta"); robots.setAttribute("name", "robots"); document.head.appendChild(robots); }
    robots.setAttribute("content", "index,follow");
  }, [doc]);

  if (!doc) return null;

  return (
    <section className="container-x py-16 md:py-24" data-testid={`legal-${type}`}>
      <div className="max-w-3xl mx-auto">
        <Link to={`/${lang}`} className="inline-flex items-center gap-2 text-sm text-subtle hover:text-copper transition-colors mb-8" data-testid="legal-back">
          <ArrowLeft size={16} /> {t(lang, "backHome")}
        </Link>
        <h1 className="text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-ink">{doc.title}</h1>
        <p className="text-faint text-sm mt-3">{doc.updated}</p>
        <div className="w-16 h-1 bg-copper mt-6 rounded-full" />
        <div className="mt-10 space-y-8">
          {doc.sections.map((s, i) => (
            <div key={i} data-testid={`legal-section-${i}`}>
              <h2 className="text-lg font-semibold text-ink mb-2">{i + 1}. {s.h}</h2>
              <p className="text-subtle leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
